const t = "_defaultStyle_r3cpb_105", n = "_highlightStyle_r3cpb_106", o = "_darkMode_r3cpb_109", l = "_lightMode_r3cpb_116", _ = "_Link_r3cpb_161", e = "_noAnimation_r3cpb_193", i = "_UnstyledButton_r3cpb_208", c = {
  defaultStyle: t,
  highlightStyle: n,
  darkMode: o,
  lightMode: l,
  Link: _,
  noAnimation: e,
  UnstyledButton: i
};
export {
  c as g
};
//# sourceMappingURL=index.module-IS0TU87b.js.map
